var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tabs",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.leadId.isClient && _vm.isEdit
        ? _c(
            "b-card",
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.makeCustomer()
                    },
                  },
                },
                [_vm._v(" Make Customer ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-tab",
        { attrs: { title: "Contacts", active: "" } },
        [_c("ContactList")],
        1
      ),
      _c(
        "b-tab",
        { attrs: { title: "Lead Info", isEdit: _vm.isEdit } },
        [_c("b-card", [_c("LeadInfo")], 1)],
        1
      ),
      _c(
        "b-tab",
        { attrs: { title: "Quotation" } },
        [_c("b-card", [_c("Quotation")], 1)],
        1
      ),
      _c("b-tab", { attrs: { title: "Opportunity" } }, [_c("Opportunity")], 1),
      _c("b-tab", { attrs: { title: "Note" } }, [_c("ToDo")], 1),
      _c("b-tab", { attrs: { title: "Task" } }, [_c("Task")], 1),
      _c("b-tab", { attrs: { title: "File Management" } }, [_c("FileMgt")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }